/**
 * Registers the offline page's worker (installable design §4). The app never
 * depends on it. A browser without workers, or one that refuses this one
 * (the Vite dev server has no `/sw.js`), runs exactly as before.
 */
export function registerServiceWorker(
  container: Pick<ServiceWorkerContainer, 'register'> | undefined,
  whenLoaded: (run: () => void) => void,
): void {
  if (!container) return;
  whenLoaded(() => {
    container.register('/sw.js').catch((error: unknown) => {
      console.warn(
        "sw: the offline page's worker was refused, so a launch with no tutor shows the browser's own error:",
        error,
      );
    });
  });
}
